import { Customers } from './routes'
import axios from 'axios'
import { cacheGetList, cacheSetList, cacheGetRecord, cacheSetRecord } from './cacheManager'

export const getCustomers = () => {
  // Check cache first
  const cached = cacheGetList('customers')
  if (cached) {
    console.log('[Service] Returning cached customers')
    return Promise.resolve({ data: { data: cached } })
  }

  // Fetch fresh from API
  return axios.get(`/api/show_customers`).then((res) => {
    if (res.data.data) {
      cacheSetList('customers', res.data.data)
    }
    return res
  })
}

export const getCustomerSingle = (id) => {
  // Check cache first
  const cached = cacheGetRecord('customers', id)
  if (cached) {
    console.log('[Service] Returning cached customer:', id)
    return Promise.resolve({ data: { data: cached } })
  }

  // Fetch fresh from API
  return axios.get(`${Customers}/${id}/edit`).then((res) => {
    if (res.data.data) {
      cacheSetRecord('customers', id, res.data.data)
    }
    return res
  })
}

export const createCustomers = (data) => {
  return axios.post(`${Customers}`, data)
}

export const updateCustomers = (id, data) => {
  return axios.put(`${Customers}/${id}`, data)
}

export const deleteCustomer = (id) => {
  return axios.delete(`${Customers}/${id}`)
}
